export default __webpack_public_path__ + "static/media/pattern-002-1.7ddbcc31.jpg";